import { preparePrevValuesDictionaryData } from '@/core/support_gui_components/prevValuesDictionary/prevValuesDictionary'

export function initDataInTextInput (attributeElementId, data) {
	if (data == undefined) {
		return
	}
	var $editor = $('#' + attributeElementId)
	if ($editor.hasClass('dictionary-list')) {
		preparePrevValuesDictionaryData($editor, data)
	}
	$editor.val(data)
}

export function initDataInBoolean (attributeElementId, data) {
	var field, value = data
	if (data == 'null' || data == null || data == undefined) {
		if ($('#' + attributeElementId).attr('data-empty-value') == 'true') {
			field = 'indeterminate'
			value = true
		} else {
			field = 'checked'
			value = false
		}
	} else {
		field = 'checked'
		value = data == 'true' || data == true
	}

	$('#' + attributeElementId).prop(field, value)
	if (data == null) data = 'null'
	$('#' + attributeElementId + '[data-empty-value=true]').attr('data-value', data) //only for nullable B-attributes
}

export function initDataInList (attributeElementId, data) {
	if (data == undefined) {
		return
	}
	$('#' + attributeElementId).val(data)
}

export function initDataInLabel (attributeElementId, data, label) {
	if (data == undefined || label == undefined) {
		return
	}
	$('#' + attributeElementId).html(label)
	$('#' + attributeElementId).attr('value', data)
	$('#' + attributeElementId).parent().find('span.label-copy-icon').attr('value', data)
}

export function initImageData (attributeElementId, data) {
	if (data == undefined) {
		return
	}
	$('#' + attributeElementId).attr('src', window.urlContext + 'attachment?id=' + data + '&token=' + localStorage.getItem('user-token'));
}
